import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  Button,
  IconButton,
  Stack,
  Typography,
  Divider,
  CircularProgress,
  Checkbox,
  ListItemText,
  FormHelperText,
  Skeleton,
  Card,
  CardMedia,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import React, { useEffect, useState } from "react";
import uploadImage from "../../../../assets/Images/Upload.png";
import { EyeIcon } from "lucide-react";
import { UploadImages } from "../../../../Core/UploadImages";
import moment from "moment-timezone";
import DeleteIcon from "@mui/icons-material/Delete";
import ic_play from "../../../../assets/Images/ic_play.png";
import {
  apiCallActiveEventTypes,
  apiCallAddVenueEvent,
  apiCallDeleteEventMedia,
  apiCallEventMediaAdd,
  apiCallEventStatusChange,
  apiCallGetEventWiseMedia,
  apiCallUpdateVenueEvent,
  apiCallUserList,
  apiCallVenueEvent,
} from "../../../../Core/Apicall";
import { useSelector } from "react-redux";
import { RootState } from "../../../../Redux/Store";
import { toast } from "react-toastify";
import VenueTopMediaPhotoGallery from "../../../Common/ImageGallery/VenueTopMediaPhotoGallery";

type ImageType = { url: string; mediaType: string; thumbnailUrl: string };

type ScheduleItem = {
  eventName: string;
  publicProfileName: string;
  eventStartTime: string;
  eventEndTime: string;
  eventTypeId: string;
  isActive: boolean;
  person: string;
  eventTypeName: string;
  bannerImage: ImageType;
};

type DaySchedule = {
  eventStartDate: number;
  month: number;
  _id: number;
  year: number;
  day: string;
  events: ScheduleItem[];
};

type EventMedia = {
  _id: string;
  eventId: string;
  thumbnailMediaUrl: string;
  mediaUrl: string;
  mediaType: string;
};

type EventFormType = {
  eventName: string;
  eventStartDate: string;
  eventStartTime: string;
  eventEndTime: string;
  description: string;
  eventTypeId: string;
  bannerImage: ImageType;
  publicProfileIds: string[];
};

type Props = {
  venueId: string;
  venueName: string;
  timeZone: string;
};
const VenueEvent: React.FC<Props> = ({ venueId, venueName, timeZone }) => {
  const currentDate = new Date();

  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth());
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openPreview, setOpenPreview] = useState(false);
  const [mediaList, setMediaList] = useState<EventMedia[]>([]);
  const [loading, setLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<string | null>(null);
  const [schedules, setSchedules] = React.useState<DaySchedule[]>([]);
  const [viewOpen, setViewOpen] = useState(false);
  const [viewEvent, setViewEvent] = useState<any>(null);
  const userdata: any = useSelector((state: RootState) => state.global.token);
  const [eventTypeList, setEventTypeList] = useState<any[]>([]);
  const [publicProfileList, setPublicProfileList] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editingEventId, setEditingEventId] = useState<string | null>(null);
  const [open, setOpen] = React.useState(false);
  const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const rowsPerPage = 12;
  const hasMore = page * rowsPerPage < totalCount;

  const [eventForm, setEventForm] = React.useState<EventFormType>({
    eventName: "",
    eventStartDate: "",
    eventStartTime: "",
    eventEndTime: "",
    eventTypeId: "",
    description: "",
    bannerImage: { url: "", mediaType: "", thumbnailUrl: "" },
    publicProfileIds: [] as string[],
  });

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const yearOptions = Array.from({ length: 6 }, (_, i) => {
    return currentDate.getFullYear() + i;
  });

  const handleChange = (key: keyof EventFormType, value: any) => {
    setEventForm({ ...eventForm, [key]: value });
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  useEffect(() => {
    fetchEventTypes();
    fetchPublicProfile();
  }, []);

  useEffect(() => {
    fetchVenueEvent();
  }, [selectedMonth, selectedYear]);

  const fetchVenueEvent = async () => {
    try {
      setLoading(true);

      const param = {
        venueId,
        timeZone,
        month: selectedMonth,
        year: selectedYear,
      };
      const res = await apiCallVenueEvent(param);
      setSchedules(res.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const fetchEventTypes = async () => {
    try {
      const res = await apiCallActiveEventTypes({});
      setEventTypeList(res?.data);
    } catch (err) { }
  };
  const fetchPublicProfile = async () => {
    try {
      const response = await apiCallUserList({
        userId: userdata?.data?.userId,
        role: 6,
        offset: 1,
        limit: 1000,
      });
      setPublicProfileList(response?.data);
    } catch (err) { }
  };

  const handleAddEvent = async () => {
    const newErrors: { [key: string]: string } = {};
    if (!eventForm.eventName) newErrors.eventName = "Event Name is required";
    if (!eventForm.eventStartDate)
      newErrors.eventStartDate = "Event Date is required";
    if (!eventForm.eventStartTime)
      newErrors.eventStartTime = "Start Time is required";
    if (!eventForm.eventEndTime)
      newErrors.eventEndTime = "End Time is required";
    if (!eventForm.eventTypeId)
      newErrors.eventTypeId = "Event Type is required";
    if (!eventForm.description)
      newErrors.description = "Description is required";
    if (!eventForm.bannerImage?.url)
      newErrors.bannerImage = "Banner image is required";

    if (eventForm.eventStartTime && eventForm.eventEndTime) {
      const start = moment(eventForm.eventStartTime, "HH:mm");
      const end = moment(eventForm.eventEndTime, "HH:mm");

      if (end.isSameOrBefore(start)) {
        newErrors.eventEndTime = "End Time must be greater than Start Time";
      }
    }


    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const payload = {
      ...eventForm,
      venueId: venueId,
      eventStartDate: moment
        .tz(eventForm.eventStartDate, "YYYY-MM-DD", timeZone)
        .startOf("day")
        .utc()
        .toDate(),
      eventStartTime: (() => {
        const startDate = moment.tz(
          eventForm.eventStartDate,
          "YYYY-MM-DD",
          timeZone,
        );
        const startTime = moment.tz(
          eventForm.eventStartTime,
          "HH:mm",
          timeZone,
        );
        return startDate
          .hour(startTime.hour())
          .minute(startTime.minute())
          .second(0)
          .millisecond(0)
          .utc()
          .toDate();
      })(),
      eventEndTime: (() => {
        const startDate = moment.tz(
          eventForm.eventStartDate,
          "YYYY-MM-DD",
          timeZone,
        );
        const endTime = moment.tz(eventForm.eventEndTime, "HH:mm", timeZone);
        return startDate
          .hour(endTime.hour())
          .minute(endTime.minute())
          .second(0)
          .millisecond(0)
          .utc()
          .toDate();
      })(),
    };

    if (isEdit && editingEventId) {
      let param = { ...payload, eventId: editingEventId };
      console.log("param", param);

      await apiCallUpdateVenueEvent(param);
    } else {
      await apiCallAddVenueEvent(payload);
    }

    fetchVenueEvent();
    resetForm();
    setOpen(false);
    setErrors({});
  };

  const resetForm = () => {
    setOpen(false);
    setIsEdit(false);
    setEditingEventId("");
    setEventForm({
      eventName: "",
      eventStartDate: "",
      eventStartTime: "",
      eventEndTime: "",
      eventTypeId: "",
      description: "",
      bannerImage: { url: "", mediaType: "", thumbnailUrl: "" },
      publicProfileIds: [],
    });
  };

  const handleFileUploadBannerImage = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setEventForm((prev) => ({
      ...prev,
      bannerImage: {
        url: URL.createObjectURL(file),
        mediaType: "Uploading_0",
        thumbnailUrl: "",
      },
    }));
    try {
      const res = await UploadImages(
        file,
        "venue_event",
        undefined,
        undefined,
        venueId,
        (percent: number) => {
          setEventForm((prev) => ({
            ...prev,
            bannerImage: {
              ...prev.bannerImage,
              mediaType: `Uploading_${percent}`,
            },
          }));
        },
      );
      if (res?.status) {
        setEventForm((prev) => ({
          ...prev,
          bannerImage: {
            url: res.location,
            mediaType: "Image",
            thumbnailUrl: res.thumbnail,
          },
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const tempId = `temp-${Date.now()}`;

    const tempMedia: EventMedia = {
      _id: tempId,
      eventId: viewEvent._id ?? "",
      thumbnailMediaUrl: "",
      mediaUrl: URL.createObjectURL(file),
      mediaType: "Uploading_0",
    };
    setMediaList((prev) => [tempMedia, ...prev]);

    try {
      const uploadRes = await UploadImages(
        file,
        "venue_event",
        undefined,
        undefined,
        viewEvent._id,
        (percent: number) => {
          setMediaList((prev) =>
            prev.map((item) =>
              item._id === tempId
                ? { ...item, mediaType: `Uploading_${percent}` }
                : item,
            ),
          );
        },
      );

      if (!uploadRes?.location) {
        setMediaList((prev) => prev.filter((m) => m._id !== tempId));
        return;
      }

      let mediaType: "Image" | "Video" | "Audio" = "Image";
      const fileUrl = uploadRes.location.toLowerCase();
      if (/\.(mp4|mov|avi|mkv|webm)$/i.test(fileUrl)) mediaType = "Video";
      if (/\.(mp3|wav|ogg)$/i.test(fileUrl)) mediaType = "Audio";

      await apiCallEventMediaAdd({
        eventId: viewEvent._id,
        mediaUrl: uploadRes.location,
        thumbnailMediaUrl: uploadRes.thumbnail,
        mediaType,
      });
      fetchMedia(1, viewEvent);
    } catch (err) {
      setMediaList((prev) => prev.filter((m) => m._id !== tempId));
    }
  };

  const handleViewEvent = (event: any) => {
    setViewEvent(event);
    setViewOpen(true);
    fetchMedia(1, event);
  };

  const fetchMedia = async (newPage = 1, event: any) => {
    try {
      setLoading(true);
      const res = await apiCallGetEventWiseMedia({
        eventId: event._id,
        offset: newPage,
        limit: rowsPerPage,
      });
      setTotalCount(res?.totalCount);
      if (res.data) {
        if (newPage === 1) {
          setMediaList(res.data);
        } else {
          setMediaList((prev) => [...prev, ...res.data]);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleEditEvent = (event: any) => {
    setIsEdit(true);
    setEditingEventId(event._id);
    setEventForm({
      eventName: event.eventName || "",
      eventStartDate: moment
        .tz(event.eventStartDate, timeZone)
        .format("YYYY-MM-DD"),
      eventStartTime: moment.tz(event.eventStartTime, timeZone).format("HH:mm"),
      eventEndTime: moment.tz(event.eventEndTime, timeZone).format("HH:mm"),
      description: event.description || "",
      eventTypeId: event.eventTypeId,
      publicProfileIds: event.publicProfiles
        ? event.publicProfiles.map((p: any) => p._id)
        : [],
      bannerImage: event.bannerImage || {
        url: "",
        mediaType: "",
        thumbnailUrl: "",
      },
    });

    setErrors({});
    setOpen(true);
  };

  const handleToggleActive = async (item: any) => {
    try {
      const param = {
        venueId,
        eventId: item._id,
        isActive: !item.isActive,
      };
      const res = await apiCallEventStatusChange(param);
      if (res?.status) {
        setSchedules((prev) =>
          prev.map((day) => ({
            ...day,
            events: day.events.map((e: any) =>
              e._id === item._id ? { ...e, isActive: !e.isActive } : e,
            ),
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteEvent = async (item: any) => {
    try {
      if (!window.confirm("Are you sure you want to delete this event?"))
        return;

      const param = {
        venueId,
        eventId: item._id,
        isDelete: true,
      };
      const res = await apiCallEventStatusChange(param);
      if (res?.status) {
        fetchVenueEvent();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleLoadMoreGallery = async () => {
    if (!hasMore || loading) return;
    const nextPage = page + 1;
    setPage(nextPage);
    fetchMedia(nextPage, viewEvent);
  };

  const handleDelete = async (id: string) => {
    try {
      await apiCallDeleteEventMedia({
        mediaId: id,
        isDelete: true,
      });
      setMediaList((prev) => prev.filter((m) => m._id !== id));
      toast.success("Deleted successfully");
    } catch (error) { }
  };

  return (
    <div
      style={{
        padding: 20,
        fontFamily: "Segoe UI, sans-serif",
        background: "#FFF",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          justifyContent: "end",
          margin: "20px 0",
          padding: "14px 16px",
          background: "#fff",
          borderRadius: 14,
        }}
      >
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Month</InputLabel>
          <Select
            value={selectedMonth}
            label="Month"
            onChange={(e) => setSelectedMonth(Number(e.target.value))}
          >
            {months.map((m, index) => (
              <MenuItem key={index} value={index}>
                {m}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Year</InputLabel>
          <Select
            value={selectedYear}
            label="Year"
            onChange={(e) => setSelectedYear(Number(e.target.value))}
          >
            {yearOptions.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ background: "#000" }}
          onClick={() => setOpen(true)}
        >
          Add Event
        </Button>
      </div>

      {loading ? (
        <Stack spacing={4}>
          {Array.from({ length: 3 }).map((_, dayIndex) => (
            <Box key={dayIndex} display="flex" gap={3}>
              {/* DATE COLUMN */}
              <Box width={90} textAlign="center">
                <Skeleton
                  variant="text"
                  width={40}
                  height={40}
                  sx={{ mx: "auto" }}
                />
                <Skeleton
                  variant="text"
                  width={60}
                  height={18}
                  sx={{ mx: "auto", mt: 1 }}
                />
                <Skeleton
                  variant="text"
                  width={50}
                  height={14}
                  sx={{ mx: "auto", mt: 0.5 }}
                />
              </Box>

              {/* EVENT GRID */}
              <Box
                display="grid"
                gridTemplateColumns="repeat(auto-fill, minmax(240px, 1fr))"
                gap={3}
                flex={1}
              >
                {Array.from({ length: 2 }).map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      borderRadius: 3,
                      overflow: "hidden",
                      height: 240,
                      position: "relative",
                    }}
                  >
                    {/* Banner Image Skeleton */}
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height="140px"
                      sx={{ borderRadius: 3 }}
                    />

                    {/* Event Text */}
                    <Box sx={{ p: 2 }}>
                      <Skeleton variant="text" width="60%" height={18} />
                      <Skeleton
                        variant="text"
                        width="40%"
                        height={14}
                        sx={{ mt: 1 }}
                      />
                    </Box>

                    {/* Event Type Chip */}
                    <Skeleton
                      variant="rectangular"
                      width={60}
                      height={20}
                      sx={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        borderRadius: 10,
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Stack>
      ) : schedules.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 200, // adjust based on your layout
            fontSize: 16,
            color: "#666",
          }}
        >
          No events found
        </Box>
      ) : (
        schedules.map((item, dayIndex) => (
          <React.Fragment key={dayIndex}>
            <div style={{ display: "flex", gap: 18 }}>
              {/* DATE COLUMN */}
              <div
                style={{
                  width: 90,
                  textAlign: "center",
                  paddingTop: 8,
                  flexShrink: 0,
                }}
              >
                <div style={{ fontSize: 42, fontWeight: 800, lineHeight: 1 }}>
                  {moment.tz(item._id, timeZone).format("DD")}
                </div>
                <div style={{ fontWeight: 700, color: "#444", marginTop: 4 }}>
                  {moment.tz(item._id, timeZone).format("MMM")}
                </div>
                <div style={{ fontSize: 12, color: "#999", marginTop: 2 }}>
                  {moment.tz(item._id, timeZone).format("dddd")}
                </div>
              </div>

              {/* EVENT GRID */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                  gap: 22,
                  width: "100%",
                }}
              >
                {item.events.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                      borderRadius: 18,
                      overflow: "hidden",
                      height: 240,
                      color: "#fff",
                      backgroundImage: item.bannerImage?.thumbnailUrl
                        ? `url(${item.bannerImage.thumbnailUrl})`
                        : "linear-gradient(135deg,#667eea,#764ba2)",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      boxShadow: "0 10px 30px rgba(0,0,0,.2)",
                      transition: "all .35s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-6px)";
                      e.currentTarget.style.boxShadow =
                        "0 20px 45px rgba(0,0,0,.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0,0,0,.2)";
                    }}
                  >
                    {/* DARK GRADIENT */}
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(180deg, rgba(0,0,0,.25) 0%, rgba(0,0,0,.85) 80%)",
                      }}
                    />

                    {/* CONTENT */}
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        padding: 18,
                        zIndex: 1,
                      }}
                    >
                      {/* TOP CONTENT */}
                      <div>
                        <div
                          style={{
                            fontSize: 18,
                            fontWeight: 800,
                            lineHeight: 1.25,
                          }}
                        >
                          {item.eventName}
                        </div>

                        <div
                          style={{
                            fontSize: 12,
                            opacity: 0.9,
                            marginTop: 6,
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          ⏰{" "}
                          {moment
                            .tz(item.eventStartTime, timeZone)
                            .format("hh:mm A")}
                          <span style={{ opacity: 0.6 }}>–</span>
                          {moment
                            .tz(item.eventEndTime, timeZone)
                            .format("hh:mm A")}
                        </div>

                        <div
                          style={{
                            fontSize: 12,
                            opacity: 0.9,
                            marginTop: 6,
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          🏷️ {item.eventTypeName}
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "auto",
                          gap: 6, // space between buttons
                        }}
                      >
                        {/* View */}
                        <Tooltip title="View Event">
                          <IconButton
                            size="small"
                            onClick={() => handleViewEvent(item)}
                            sx={{
                              color: "#fff",
                              background: "rgba(255,255,255,.18)",
                              backdropFilter: "blur(6px)",
                              "&:hover": { background: "#F6A623" },
                            }}
                          >
                            <EyeIcon />
                          </IconButton>
                        </Tooltip>

                        {/* Edit */}
                        <Tooltip title="Edit Event">
                          <IconButton
                            size="small"
                            onClick={() => handleEditEvent(item)}
                            sx={{
                              color: "#fff",
                              background: "rgba(255,255,255,.18)",
                              backdropFilter: "blur(6px)",
                              "&:hover": { background: "#F6A623" },
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* Delete */}
                        <Tooltip title="Delete Event">
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteEvent(item)}
                            sx={{
                              color: "#fff",
                              background: "rgba(255,255,255,.18)",
                              backdropFilter: "blur(6px)",
                              "&:hover": { background: "#FF3D00" },
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* Active / Inactive */}
                        <Tooltip
                          title={
                            item.isActive
                              ? "Deactivate Event"
                              : "Activate Event"
                          }
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleToggleActive(item)}
                            sx={{
                              color: "#fff",
                              background: "rgba(255,255,255,.18)",
                              backdropFilter: "blur(6px)",
                              "&:hover": {
                                background: "rgba(255,255,255,.18)",
                              },
                            }}
                          >
                            {item.isActive ? "🟢" : "⚪"}
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {item.events.length > 0 &&
              schedules[dayIndex + 1]?.events?.length > 0 && (
                <div
                  style={{
                    width: "100%",
                    height: 1,
                    background:
                      "linear-gradient(to right, transparent, #ccc, transparent)",
                    margin: "40px 0",
                  }}
                />
              )}
          </React.Fragment>
        ))
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            background: "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            overflow: "hidden",
          },
        }}
      >
        {/* ===== TITLE ===== */}
        <DialogTitle
          sx={{
            fontWeight: 800,
            fontSize: 22,
            textAlign: "center",
            py: 2,
            background: "linear-gradient(135deg,#000,#2C2C2C)",
            color: "#fff",
          }}
        >
          {isEdit ? "Edit Event" : "Add Event"}
        </DialogTitle>

        <Divider />

        {/* ===== CONTENT ===== */}
        <DialogContent
          sx={{
            px: 3,
            py: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {/* Event Name */}
          <TextField
            label="Event Name"
            fullWidth
            size="small"
            value={eventForm.eventName}
            onChange={(e) => handleChange("eventName", e.target.value)}
            error={!!errors.eventName}
            helperText={errors.eventName}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          />

          {/* Event Date */}
          <TextField
            label="Event Date"
            type="date"
            fullWidth
            size="small"
            inputProps={{ min: new Date().toISOString().split("T")[0] }}
            InputLabelProps={{ shrink: true }}
            value={eventForm.eventStartDate}
            onChange={(e) => handleChange("eventStartDate", e.target.value)}
            error={!!errors.eventStartDate}
            helperText={errors.eventStartDate}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          />

          {/* Time */}
          <Box display="flex" gap={1.5}>
            <TextField
              label="Start Time"
              type="time"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              value={eventForm.eventStartTime}
              error={!!errors.eventStartTime}
              helperText={errors.eventStartTime}
              onChange={(e) => handleChange("eventStartTime", e.target.value)}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
            />

            <TextField
              label="End Time"
              type="time"
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              value={eventForm.eventEndTime}
              error={!!errors.eventEndTime}
              helperText={errors.eventEndTime}
              onChange={(e) => handleChange("eventEndTime", e.target.value)}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
            />
          </Box>

          {/* Event Type */}
          <FormControl
            fullWidth
            size="small"
            error={!!errors.eventTypeId}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          >
            <InputLabel>Event Type</InputLabel>
            <Select
              label="Event Type"
              value={eventForm.eventTypeId || ""}
              onChange={(e) =>
                setEventForm((prev: any) => ({
                  ...prev,
                  eventTypeId: e.target.value,
                }))
              }
            >
              <MenuItem value="">Select Event Type</MenuItem>
              {eventTypeList.map((item: any) => (
                <MenuItem key={item._id} value={item._id}>
                  {item.typeName}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.eventTypeId}</FormHelperText>
          </FormControl>

          {/* Public Profile */}
          <FormControl
            fullWidth
            size="small"
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          >
            <InputLabel>Public Profile</InputLabel>

            <Select
              multiple
              label="Public Profile"
              value={eventForm.publicProfileIds}
              onChange={(e) =>
                setEventForm((prev: any) => ({
                  ...prev,
                  publicProfileIds: e.target.value as string[],
                }))
              }
              renderValue={(selected) =>
                publicProfileList
                  .filter((item: any) => selected.includes(item._id))
                  .map((item: any) => item.fullName)
                  .join(", ")
              }
            >
              {publicProfileList.map((item: any) => (
                <MenuItem key={item._id} value={item._id}>
                  {/* ✅ Checkbox */}
                  <Checkbox
                    checked={eventForm.publicProfileIds.includes(item._id)}
                  />

                  {/* Name */}
                  <ListItemText primary={item.fullName} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Description */}
          <TextField
            label="Event Description"
            multiline
            rows={4}
            size="small"
            value={eventForm.description}
            onChange={(e) => handleChange("description", e.target.value)}
            error={!!errors.description}
            helperText={errors.description}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          />

          {/* Banner Image */}
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: `1px solid ${errors.bannerImage ? "#d32f2f" : "#eee"}`,

              backgroundColor: "#fff",
            }}
          >
            <Typography
              fontWeight={600}
              color={errors.bannerImage ? "error.main" : "text.primary"}
              fontSize={14}
              mb={1.5}
            >
              Banner Image
            </Typography>

            <Box display="flex" gap={2} flexWrap="wrap">
              {/* Preview / Uploading */}
              {(eventForm.bannerImage.thumbnailUrl ||
                eventForm.bannerImage.mediaType?.startsWith("Uploading")) && (
                  <Box
                    sx={{
                      position: "relative",
                      width: 96,
                      height: 96,
                      borderRadius: 3,
                      overflow: "hidden",
                      boxShadow: 1,
                    }}
                  >
                    {/* Image */}
                    {eventForm.bannerImage.thumbnailUrl && (
                      <img
                        src={eventForm.bannerImage.thumbnailUrl}
                        alt="banner"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          filter: eventForm.bannerImage.mediaType.startsWith(
                            "Uploading",
                          )
                            ? "blur(2px)"
                            : "none",
                        }}
                      />
                    )}

                    {/* Uploading overlay */}
                    {eventForm.bannerImage.mediaType?.startsWith("Uploading") && (
                      <Box
                        sx={{
                          position: "absolute",
                          inset: 0,
                          bgcolor: "rgba(255,255,255,.75)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <CircularProgress
                          variant="determinate"
                          value={parseInt(
                            eventForm.bannerImage.mediaType.split("_")[1] || "0",
                          )}
                          size={42}
                          thickness={4}
                          sx={{ color: "#000" }}
                        />
                        <Typography
                          variant="caption"
                          fontWeight={700}
                          mt={0.5}
                          color="text.primary"
                        >
                          {eventForm.bannerImage.mediaType.split("_")[1] || 0}%
                        </Typography>
                      </Box>
                    )}

                    {/* Remove */}
                    {!eventForm.bannerImage.mediaType?.startsWith(
                      "Uploading",
                    ) && (
                        <IconButton
                          size="small"
                          sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            bgcolor: "#fff",
                            width: 20,
                            height: 20,
                            boxShadow: 1,
                          }}
                          onClick={() =>
                            setEventForm((prev) => ({
                              ...prev,
                              bannerImage: {
                                url: "",
                                mediaType: "",
                                thumbnailUrl: "",
                              },
                            }))
                          }
                        >
                          ✕
                        </IconButton>
                      )}
                  </Box>
                )}

              {/* Upload button */}
              <IconButton
                component="label"
                sx={{
                  width: 96,
                  height: 96,
                  border: `2px dashed ${errors.bannerImage ? "#d32f2f" : "#ddd"
                    }`,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={uploadImage} width={36} />
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleFileUploadBannerImage}
                />
              </IconButton>
            </Box>

            {/* Error message */}
            {errors.bannerImage && (
              <Typography
                variant="caption"
                color="error"
                mt={0.5}
                display="block"
              >
                {errors.bannerImage}
              </Typography>
            )}
          </Box>
        </DialogContent>

        {/* ===== ACTIONS ===== */}
        <DialogActions sx={{ px: 3, py: 2, bgcolor: "#fafafa" }}>
          <Button
            onClick={() => resetForm()}
            sx={{ textTransform: "none", color: "text.secondary" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddEvent}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 4,
              boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
            }}
          >
            {isEdit ? "Update Event" : "Save Event"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={viewOpen}
        onClose={() => setViewOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: 800,
            textAlign: "center",
            background: "linear-gradient(135deg,#000,#2C2C2C)",
            color: "#fff",
          }}
        >
          Event Details
        </DialogTitle>

        <DialogContent sx={{ py: 3 }}>
          {viewEvent && (
            <>
              {viewEvent?.bannerImage?.url && (
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    height: 220,
                    borderRadius: 3,
                    overflow: "hidden",
                    mb: 2,
                    mt: 2,
                    boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
                  }}
                >
                  {/* Background Image */}
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      backgroundImage: `url(${viewEvent.bannerImage.url})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      filter: "blur(1.5px) scale(1.05)",
                    }}
                  />

                  {/* Dark Gradient Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(180deg, rgba(0,0,0,.2) 0%, rgba(0,0,0,.85) 100%)",
                    }}
                  />

                  {/* Foreground Content */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 1,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      p: 2,
                      color: "#fff",
                    }}
                  >
                    <Typography fontSize={18} fontWeight={800}>
                      {viewEvent.eventName}
                    </Typography>

                    <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                      {moment
                        .tz(viewEvent.eventStartDate, timeZone)
                        .format("DD MMM YYYY")}{" "}
                      •{" "}
                      {moment
                        .tz(viewEvent.eventStartTime, timeZone)
                        .format("hh:mm A")}{" "}
                      –{" "}
                      {moment
                        .tz(viewEvent.eventEndTime, timeZone)
                        .format("hh:mm A")}
                    </Typography>
                  </Box>
                </Box>
              )}

              <Divider sx={{ my: 2 }} />

              <Typography fontSize={14}>
                👤{" "}
                <b>
                  {viewEvent?.publicProfiles?.length
                    ? viewEvent.publicProfiles
                      .map((p: any) => p.fullName)
                      .join(", ")
                    : "N/A"}
                </b>
              </Typography>

              <Typography fontSize={14} mt={1}>
                🏷️ <b>{viewEvent.eventTypeName}</b>
              </Typography>

              <Divider sx={{ my: 2 }} />

              <Typography fontWeight={600}>Description</Typography>
              <Typography fontSize={14} mt={0.5}>
                {viewEvent.description || "N/A"}
              </Typography>

              {/* Marketing Media */}

              <Typography fontWeight={900} fontSize={14} mt={1.5} mb={0.5}>
                Event Media
              </Typography>
              <div style={{ display: "flex", gap: "20px" }}>
                {/* Upload Box */}
                <Tooltip style={{ width: "100px" }} title="Upload Image/Video">
                  <Box
                    position="relative"
                    display="inline-flex"
                    sx={{ width: 100, height: 100 }}
                  >
                    <IconButton
                      component="label"
                      sx={{
                        p: 3,
                        border: "2px dashed #999",
                        borderRadius: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 100,
                        height: 100,
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={uploadImage}
                        alt="Upload"
                        style={{ width: 40, height: 40, opacity: 0.7 }}
                      />
                      <input
                        onChange={handleFileUpload}
                        hidden
                        type="file"
                        accept="image/*,video/*"
                      />
                    </IconButton>
                  </Box>
                </Tooltip>

                {/* Media List */}
                {loading ? (
                  <CircularProgress />
                ) : (
                  <Grid container spacing={2} wrap="wrap">
                    {mediaList.map((media: any) => (
                      <Grid key={media._id}>
                        <Card
                          sx={{
                            position: "relative",
                            borderRadius: 2,
                            overflow: "hidden",
                            boxShadow: 3,
                            width: 100,
                            height: 100,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {/* 🟣 Uploading Progress */}
                          {media.mediaType.startsWith("Uploading") ? (
                            <>
                              <CircularProgress
                                variant="determinate"
                                value={parseInt(
                                  media.mediaType.split("_")[1] || "0",
                                )}
                                size={50}
                                sx={{
                                  color: "#000",
                                }}
                                thickness={3.5}
                              />
                              <Typography
                                variant="caption"
                                sx={{
                                  position: "absolute",
                                  color: "#000",
                                  fontWeight: "bold",
                                }}
                              >
                                {media.mediaType.split("_")[1] || 0}%
                              </Typography>
                            </>
                          ) : (
                            <>
                              {/* Delete Button */}
                              <IconButton
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  zIndex: 5,
                                  bgcolor: "rgba(255,255,255,0.8)",
                                  "&:hover": {
                                    bgcolor: "rgba(255,0,0,0.9)",
                                    color: "white",
                                  },
                                }}
                                onClick={() => setDeleteDialogOpen(media._id)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>

                              {/* Delete Confirmation Dialog */}
                              {deleteDialogOpen === media._id && (
                                <Dialog
                                  open={Boolean(deleteDialogOpen)}
                                  onClose={() => setDeleteDialogOpen(null)}
                                >
                                  <DialogTitle>
                                    Are you sure you want to delete this media?
                                  </DialogTitle>
                                  <DialogActions>
                                    <Button
                                      onClick={() => setDeleteDialogOpen(null)}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      color="error"
                                      variant="contained"
                                      onClick={() => handleDelete(media._id)}
                                    >
                                      Delete
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              )}
                              {/* Image / Video */}
                              {media.mediaUrl?.match(
                                /\.(jpg|jpeg|png|gif|webp|avif)$/i,
                              ) ? (
                                <CardMedia
                                  component="img"
                                  image={media.mediaUrl}
                                  sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    const idx = mediaList.findIndex(
                                      (m) => m._id === media._id,
                                    );
                                    setSelectedIndex(idx);
                                    setOpenPreview(true);
                                  }}
                                />
                              ) : media.mediaUrl?.match(
                                /\.(mp4|mov|avi|mkv|webm)$/i,
                              ) ? (
                                <>
                                  <CardMedia
                                    component="img"
                                    image={
                                      media?.thumbnailMediaUrl || media.mediaUrl
                                    }
                                    sx={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      cursor: "pointer",
                                      opacity: 0.9,
                                    }}
                                    onClick={() => {
                                      const idx = mediaList.findIndex(
                                        (m) => m._id === media._id,
                                      );
                                      setSelectedIndex(idx);
                                      setOpenPreview(true);
                                    }}
                                  />
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 30,
                                        height: 30,
                                        borderRadius: "50%",
                                        backgroundColor: "rgba(0,0,0,0.6)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <img
                                        src={ic_play}
                                        alt="Play"
                                        style={{
                                          width: 10,
                                          height: 10,
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                </>
                              ) : (
                                <Typography variant="caption">
                                  Unsupported
                                </Typography>
                              )}
                            </>
                          )}
                        </Card>
                      </Grid>
                    ))}

                    {hasMore && !loading && (
                      <div
                        style={{
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          onClick={() => {
                            const nextPage = page + 1;
                            setPage(nextPage);
                            fetchMedia(nextPage, viewEvent);
                          }}
                          sx={{
                            cursor: "pointer",
                            px: 1.8,
                            py: 0.6,
                            borderRadius: "18px",
                            background:
                              "linear-gradient(135deg, #4A90E2, #007AFF)",
                            color: "white",
                            fontWeight: 500,
                            fontSize: "12px",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                            transition: "0.2s",
                            display: "inline-flex",
                            alignItems: "center",
                            "&:hover": {
                              transform: "translateY(-1px)",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                            },
                          }}
                        >
                          View More
                        </Box>
                      </div>
                    )}
                  </Grid>
                )}
              </div>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setViewOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {openPreview && (
        <VenueTopMediaPhotoGallery
          open={openPreview}
          venueName={viewEvent.eventName}
          mediaList={mediaList}
          selectedIndex={selectedIndex}
          onClose={() => setOpenPreview(false)}
          onEndReached={handleLoadMoreGallery}
        />
      )}
    </div>
  );
};

export default VenueEvent;
